<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
// import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";

import { salesAnalyticsDonutChart, ChatData } from "./data";

/**
 * Saas Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    // PageHeader,
  },
  data() {
    return {
      salesAnalyticsDonutChart: salesAnalyticsDonutChart,
      ChatData: ChatData,
      title: "Dashboards",
      items: [
        {
          text: "Dashboards",
          // href: "/",
        },
        {
          text: "Inicio rápido",
          active: true,
        },
      ],
      submitted: false,
      chat: {
        message: "",
      },
    };
  },
  validations: {
    chat: {
      message: {
        required,
      },
    },
  },
  methods: {
    /**
     * Char form Submit
     */
    // eslint-disable-next-line no-unused-vars
    formSubmit(e) {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const id = this.ChatData.length;
        const message = this.chat.message;
        const currentDate = new Date();
        this.ChatData.push({
          id: id + 1,
          align: "right",
          name: "Henry Wells",
          message,
          time: currentDate.getHours() + ":" + currentDate.getMinutes(),
        });
        this.handleScroll();
      }
      this.submitted = false;
      this.chat = {};
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },
  },
  mounted() {
    /*   var container2 = document.querySelector(
      "#containerElement .simplebar-content-wrapper"
    );
    container2.scrollTo({ top: 500, behavior: "smooth" }); */
  },
};
</script>
<template>
  <Layout>
    <div class="welcome-container">
      <div class="content-section">
        <h1 class="welcome-title">Bienvenido A Multi Repuestos San Jose</h1>
        <div class="card-container">
          <router-link :to="{ name: 'productos' }" class="card-link">
            <div class="elegant-card inventory">
              <i class="icon fas fa-boxes"></i>
              <h3>Inventario</h3>
              <p>Gestionar productos</p>
            </div>
          </router-link>
          <router-link :to="{ name: 'ventas' }" class="card-link">
            <div class="elegant-card sales">
              <i class="icon fas fa-cash-register"></i>
              <h3>Ventas</h3>
              <p>Nueva venta</p>
            </div>
          </router-link>
          <router-link :to="{ name: 'compras' }" class="card-link">
            <div class="elegant-card workshop">
              <i class="icon fas fa-tools"></i>
              <h3>Compras</h3>
              <p>Compra de productos</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.welcome-container {
  min-height: 100vh;
  background: 
  linear-gradient(to bottom, 
    rgba(220, 225, 235, 0.6) 0%, 
    rgba(228, 233, 240, 0.6) 70%, 
    rgba(228, 233, 240, 0.4) 100%),
  url('~@/assets/images/profile-img.png') no-repeat bottom center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 2rem;
  color: #333;
}

.content-section {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.welcome-title {
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
}

.card-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.elegant-card {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
}

.elegant-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

h3 {
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

p {
  font-size: 0.9rem;
  opacity: 0.8;
}

.card-link {
  text-decoration: none;
  color: inherit;
}

/* Responsive Design */
@media (min-width: 768px) {
  .welcome-title {
    font-size: 3.5rem;
  }
}

@media (max-width: 767px) {
  .card-container {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 1200px) {
  .welcome-container {
    padding: 4rem;
  }

  .card-container {
    gap: 2rem;
  }
}
</style>